<header class="section-header d-none">
    <section class="header-main">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-3 col-lg-3 col-12">
                    <a routerLink="/" class="brand-wrap">
                        <img class="logo" [src]="companyLogo">
                    </a> <!-- brand-wrap.// -->
                </div>
                <div class="col-md-4 col-lg-5 col-12">

                    <div class="input-group">
                        <input type="text" class="form-control" [(ngModel)]="searchText" placeholder="Search">
                        <div class="input-group-append">
                            <button (click)="searchForString()" class="btn btn-theme" type="button">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>

                </div> <!-- col.// -->
                <div class="col-md-5 col-lg-4 col-sm-12 col-12 text-md-right">

                    <div style="float: left;margin: 0px 5px;">


                        <a routerLink="/cart" class="btn btn-light"> My cart <span
                                class="ml-2 badge badge-warning">{{count}}</span>
                        </a>
                        &nbsp;
                        <button class="btn float-right btn-light d-md-none" type="button" data-toggle="collapse"
                            data-target="#main_nav8" aria-controls="main_nav" aria-expanded="false"
                            aria-label="Toggle navigation">
                            <i class="fa fa-bars"></i>
                        </button>
                    </div>
                    <a routerLink="/profile" class="ml-3 icontext" aria-expanded="true">
                        <div class="icon"><i class="fa fa-lg fa-user-circle"></i></div>
                        <div class="text">

                            <span>My account <i class="fa fa-caret-down"></i></span>
                        </div>
                    </a>
                </div> <!-- col.// -->
            </div> <!-- row.// -->
        </div> <!-- container.// -->
    </section> <!-- header-main .// -->
    <nav class="navbar navbar-main navbar-expand-md navbar-light">
        <div class="container">
            <div class="collapse navbar-collapse" id="main_nav8">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a class="nav-link pl-0" href="#"> Home </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/products">Products</a>
                    </li>
                 
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/contact">About and Contact</a>
                    </li>
                </ul>

            </div> <!-- collapse .// -->
        </div> <!-- container .// -->
    </nav>

</header><!-- section-header.// -->


<header class="custom-header">
    <div class="container">
        <nav class="navbar navbar-expand-lg navbar-light bg-white">
            <a class="navbar-brand d-flex align-items-center" href="#">
                <img [src]="companyLogo" alt="Logo" class="logo">
                <span class="brand-name">DNJ</span>
            </a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
                aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse justify-content-between" id="navbarNav">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/home" class="nav-link" routerLinkActive="active">HOME</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link " routerLink="/products" routerLinkActive="active">PRODUCTS</a>
                    </li>
                  
                   
                    <li class="nav-item">
                        <a class="nav-link" class="nav-link" routerLink="/contact" routerLinkActive="active">CONTACT US</a>
                    </li>
                </ul>
                <div class="icon-group">
                    <div routerLink="/cart" class="cart-icon position-relative">
                        <i class="fa fa-shopping-cart"></i>
                        <span class="badge badge-danger">{{count}}</span>
                    </div>
        
                </div>
            </div>
        </nav>
    </div>
  
</header>